(function () {
  const d = document;
  const articleRoot =
    d.querySelector('main article') ||
    d.querySelector('.article, .article-template, .rte') ||
    d;
  const candidates = Array.from(articleRoot.querySelectorAll('img'));
  const heroCandidateByViewport = candidates.find(img => {
    const r = img.getBoundingClientRect();
    return r.top >= 0 && r.top < (window.innerHeight || 800) * 0.8;
  });
  const hero =
    articleRoot.querySelector('.article-hero img, .article-hero picture img') ||
    heroCandidateByViewport ||
    candidates[0] ||
    null;
  const imgs = Array.from(articleRoot.querySelectorAll('img'));
  imgs.forEach(img => {
    const isHero = hero && img === hero;
    if (!img.hasAttribute('decoding')) img.setAttribute('decoding', 'async');
    if (!img.hasAttribute('fetchpriority')) img.setAttribute('fetchpriority', isHero ? 'high' : 'low');
    if (isHero) {
      img.setAttribute('loading', 'eager');
    } else {
      if (!img.hasAttribute('loading')) img.setAttribute('loading', 'lazy');
    }
    if (!img.hasAttribute('width') || !img.hasAttribute('height')) {
      if (img.complete && img.naturalWidth && img.naturalHeight) {
        img.setAttribute('width', img.naturalWidth);
        img.setAttribute('height', img.naturalHeight);
      } else {
        img.addEventListener('load', function onLoad() {
          if (!img.hasAttribute('width') && img.naturalWidth) img.setAttribute('width', img.naturalWidth);
          if (!img.hasAttribute('height') && img.naturalHeight) img.setAttribute('height', img.naturalHeight);
          img.removeEventListener('load', onLoad);
        });
      }
    }
  });
  const iframes = Array.from(articleRoot.querySelectorAll('iframe'));
  iframes.forEach(f => {
    if (!f.hasAttribute('loading')) f.setAttribute('loading', 'lazy');
    if (!f.hasAttribute('referrerpolicy')) f.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
    if (!f.hasAttribute('allowfullscreen')) f.setAttribute('allowfullscreen', '');
  });
  if (!('loading' in HTMLImageElement.prototype)) {
    window.addEventListener('DOMContentLoaded', () => {
      imgs.forEach(img => { if (img.decode) img.decode().catch(()=>{}); });
    });
  }
})();